export enum AncillaryLoaderStatus {
  OFF = 'off',
  REASSIGNING = 'reassigning',
}
